import { createContext } from "react";

export const DelayPickingOrderContext = createContext();
